var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 73,
    viewBox: "0 0 69 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7d9fb1",
    strokeMiterlimit: 20,
    strokeWidth: 1.48,
    d: "M33.832 15.912a1.478 1.478 0 0 1 1.456 0l17.193 9.723c.464.263.75.754.75 1.287v19.396c0 .533-.286 1.024-.75 1.287l-17.193 9.723a1.478 1.478 0 0 1-1.456 0L16.64 47.605a1.478 1.478 0 0 1-.75-1.287V26.922c0-.533.286-1.024.75-1.287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7d9fb1",
    strokeLinecap: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.48,
    d: "M34.56 56.86V36.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7d9fb1",
    strokeLinecap: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.48,
    d: "M15.64 26.94l18.48 9.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7d9fb1",
    strokeLinecap: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.48,
    d: "M52.6 26.94l-18.48 9.68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.2d6de9a7.svg";
export { ForwardRef as ReactComponent };